import Axios from 'axios';
import React, {useState, useEffect } from 'react';

function Currencies() {
    const [rates, setRates] = useState({});

    useEffect(() => {
        Axios.get('http://data.fixer.io/api/latest?access_key=9eb343f4794ce8343f579b70151f2383').then(res => setRates(res.data.rates))
    }, []);
    let rateRows = []
    for(const rate in rates){
        rateRows.push(<tr key={rate}>
            <td>{rate}</td>
            <td>{rates[rate]}</td>
            </tr>)
    }
    console.log(rates);
        return (
        <div className="container">
        <div className="container-header">
            <h1>Currencies</h1>
            <h3>Base Currency = 1EUR</h3>
        </div>
        <div className="container-body">
            <table>
            <tbody>
            <tr>
                <th>Currency</th>
                <th>Value</th>
            </tr>
            {rateRows}
            </tbody>
            </table>
        </div>
        </div>
        )
    }

export default Currencies;